import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "info-button-close-icon" }
const _hoisted_2 = { class: "v-card-info-text ma-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    "max-width": "500"
  }, {
    activator: _withCtx(({ props: activatorProps }) => [
      _createVNode(_component_v_tooltip, {
        text: _ctx.tooltipTextValue,
        disabled: !_ctx.showTooltip
      }, {
        activator: _withCtx(( { props} ) => [
          _createVNode(_component_v_icon, _mergeProps({...activatorProps, ...props}, {
            style: {"margin-left":"1em","font-size":"1.3em","color":"var(--accent-color)"},
            elevation: "1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogVisible = true)),
            onKeydown: _ctx.handleKeydown
          }), {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" mdi-information-variant-circle-outline ", -1)
            ]))]),
            _: 1
          }, 16, ["onKeydown"])
        ]),
        _: 2
      }, 1032, ["text", "disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "gradient-background" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              class: "info-button-close-icon__icon",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = false)),
              onKeydown: _ctx.handleKeydown
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" mdi-close ", -1)
              ]))]),
              _: 1
            }, 8, ["onKeydown"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createTextVNode(_toDisplayString(_ctx.helpText), 1)
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue"]))
}